import type { BootFallbackGridSpec } from "@slot/game-shell";

/**
 * The board before the first round and after a recovery: mostly empty cells and three coins that carry no money (two
 * jackpot coins and a mystery), so it states no amount at a bet the player has not chosen. Five rows, as every board on
 * the wire: the GROW rows blank, hidden under the frame.
 */
export const BOOT_FALLBACK_GRID: BootFallbackGridSpec = {
  encodedGridSnapshot: "B,MINI,B,B|B,B,MYS,B|MINOR,B,B,B|B,B,B,B|B,B,B,B",
  reelSetIdentifier: "default",
};
